module.exports = __webpack_public_path__ + "static/img/btn_download_app.da2ee233.png";